import React from "react"

function AddCommentIcon(props) {
	return (
		<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<rect width="40" height="40" rx="6" fill="#3476E4" />
			<g clip-path="url(#clip0_3833_13829)">
				<path
					d="M19.8586 32.0209L26.9084 14.3927C27.2337 13.5725 26.4276 12.7664 25.6073 13.0916L7.97917 20.1415C7.30742 20.4031 7.13771 21.2658 7.63976 21.7678L10.8924 25.0347C11.246 25.3882 11.8117 25.4306 12.2077 25.1195L23.5355 16.4645L14.8735 27.7853C14.5694 28.1884 14.6118 28.754 14.9654 29.1076L18.2322 32.3603C18.7343 32.8623 19.5969 32.6926 19.8586 32.0209Z"
					fill="white"
				/>
			</g>
			<defs>
				<clipPath id="clip0_3833_13829">
					<rect width="24" height="24" fill="white" transform="translate(3.02954 20) rotate(-45)" />
				</clipPath>
			</defs>
		</svg>
	)
}

export default AddCommentIcon
